/**
 * @surfline/quiver-react v12.14.9 2020-10-22
 */

import React from 'react';
import 'prop-types';
import classNames from 'classnames';
import conditionClassModifier from '../helpers/conditionClassModifier.js';
import conditionEnumToText from '../helpers/conditionEnumToText.js';

const surfConditionsClass = (conditions, expired) => {
  const classObject = {};
  classObject['quiver-surf-conditions'] = true;
  classObject[`quiver-surf-conditions--${conditionClassModifier(conditions)}`] = !!conditions;
  classObject['quiver-surf-conditions--expired'] = expired;
  return classNames(classObject);
};

const SurfConditions = ({
  conditions,
  defaultCondition,
  expired
}) => {
  const conditionText = conditionEnumToText(conditions) || defaultCondition;
  return /*#__PURE__*/React.createElement("span", {
    className: surfConditionsClass(conditions, expired)
  }, !expired ? conditionText : 'Report Coming Soon');
};

SurfConditions.defaultProps = {
  conditions: null,
  defaultCondition: '',
  expired: false
};

export default SurfConditions;
//# sourceMappingURL=SurfConditions.js.map
